import React from 'react';
import Navigation from './../components/Navigation';
import HeroSection from './../components/HeroSection';
import HowWeWorkSection from './../components/HowWeWorkSection';
import ServicesSection from './../components/ServicesSection';
import MarketplaceFinalCTA from './../components/MarketplaceFinalCTA';
import Footer from './../components/Footer';


const GlobalExpedyte = (props) => {
  return (
    <div className="marketplace-home">
      <Navigation {...props} />
      
      <main className="main-content">
        <HeroSection 
          onNavigateToPostRFQ={props.onNavigateToPostRFQ}
          onNavigateToJoinFreelancer={props.onNavigateToJoinFreelancer}
        />

        
        
        <HowWeWorkSection />
        
        <ServicesSection />
        
        <MarketplaceFinalCTA 
          onNavigateToPostRFQ={props.onNavigateToPostRFQ}
          onNavigateToJoinFreelancer={props.onNavigateToJoinFreelancer}
        />
      </main>
      
      <Footer {...props} />
    </div>
  );
};

export default GlobalExpedyte;